<!--  -->
<template>
  <div>
    <div class="tabletar">
      <el-input v-model="query.id" style="width:200px" placeholder="请输入ID" />
      <el-select v-model="query.monitor_status" placeholder="请选择纳入状态" style="margin:0 20px">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.label"
          :value="item.id"
        />
      </el-select>
      <el-select v-model="query.work_status" placeholder="请选择运行状态" style="margin-right:10px">
        <el-option
          v-for="item in optionsr"
          :key="item.id"
          :label="item.label"
          :value="item.id"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="serarch">搜索</el-button>
      <el-button type="primary" icon="el-icon-search" @click="resetser">重置</el-button>
      <el-button type="primary" style="margin-bottom:20px" @click="dialogVisible = true">新增</el-button>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="180"
        />
        <el-table-column
          align="center"
          prop="phone"
          label="手机号"
          width="180"
        />
        <el-table-column
          align="center"
          prop="monitor_status"
          label="检测状态"
          width="180"
        >
          <template scope="scope">
            <!-- <el-tag v-if="scope.row.monitor_status === 1" type="success" @click="naclick(scope.row.id,scope.row.monitor_status,scope.row.phone)">已纳入</el-tag>
            <el-tag v-else type="danger" @click="naclick(scope.row.id,scope.row.monitor_status,scope.row.phone)"> 未纳入</el-tag> -->
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.ster"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="naclick(scope.row.id,scope.row.monitor_status,scope.row.phone)"
              />
              <div
                v-if="scope.row.ster"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >已纳入</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >未纳入</div>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="work_status"
          label="运行状态"
          width="180"
        >
          <template scope="scope">
            <el-tag v-if="scope.row.work_status === 1" type="success">正常</el-tag>
            <el-tag v-else type="danger">被封</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="url"
          label="链接地址"
        />
        <el-table-column
          align="center"
          prop="last_work_time"
          label="最后正常运行时间"
          width="180"
        />
        <el-table-column
          align="center"
          prop="remind_at"
          label="提醒时间"
          width="180"
        />
        <el-table-column
          align="center"
          prop="work_status"
          label="操作"
          width="180"
        >
          <template scope="scope">
            <el-button type="primary" size="mini" @click="deitphone(scope.row)">修改手机号</el-button>
            <el-button type="primary" size="mini" @click="deleter(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closempty"
    >
      <div class="sers">
        <div>手机号：</div>
        <el-input v-model="telephone" style="width:200px" :maxlength="11" placeholder="请输入内容" />
      </div>
      <div class="sers" style="margin-top:20px">
        <div>是否监测：</div>
        <el-radio v-model="radio" label="1">已纳入</el-radio>
        <el-radio v-model="radio" label="2">未纳入</el-radio>
      </div>
      <div ref="main" class="link_box">
        <div v-for="item,index in arr" :key="index" ref="content" class="sers" style="margin-top:20px">
          <div>链接地址：</div>
          <el-input v-model="item.url" style="width:200px" placeholder="请输入内容" />
          <el-button type="primary" style="margin-left:10px" @click="copy">+</el-button>
          <el-button v-if="index!==0" type="primary" style="margin-left:10px" @click="reduceclick(index)">-</el-button>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sunbit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新增"
      :visible.sync="dialogVisiblephone"
      width="30%"
    >
      <div class="sers">
        <div>手机号：</div>
        <el-input v-model="edittelephone" style="width:200px" :maxlength="11" placeholder="请输入内容" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="phonesunbit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { advertisementlist, advertisementlistadd, modifyDatar, deletemanag } from '@/api/providerAccountManagement/servicePorviderList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      options: [
        {
          id: 1,
          label: '已纳入'
        },
        {
          id: 2,
          label: '未纳入'
        }
      ],
      optionsr: [
        {
          id: 1,
          label: '正常'
        },
        {
          id: 2,
          label: '被封'
        }
      ],
      value: true,
      edittelephone: null,
      dialogVisiblephone: false,
      query: {
        id: null,
        monitor_status: null,
        page: 1,
        page_size: 10,
        work_status: null
      },
      dialogVisible: false,
      telephone: '',
      total: null,
      arr: [
        { url: '' }
      ],
      arrs: [],
      radio: '1',
      tableData: [],
      monitorstatus: null,
      item: {}
    }
  },
  created() {
    this.setdata()
  },
  mounted() {

  },
  methods: {
    async setdata() {
      const data = await advertisementlist(this.query)
      data.data.list.forEach((item) => {
        console.log('item.monitor_status', item.monitor_status)
        if (item.monitor_status === 1) {
          item.ster = true
        } else if (item.monitor_status === 2) {
          item.ster = false
        }
      })
      this.total = data.data.total
      this.tableData = data.data.list
      console.log('data', this.tableData)
    },
    copy() {
      this.arr.push({
        url: ''
      })
      this.$nextTick(() => {
        const el = document.querySelector('.link_box')
        el.scrollTop = el.scrollHeight - el.clientHeight
        // console.log(el, el.scrollTop, el.scrollHeight, el.clientHeight)
      })
    },
    async sunbit() {
      if (this.telephone === '') {
        this.$message({
          message: '请填写手机号',
          type: 'error'
        })
        return
      }
      const flag = this.arr.every(function(a) {
        return a.url !== ''
      })
      if (flag === false) {
        this.$message({
          message: '请填写链接',
          type: 'error'
        })
        return
      }
      this.arrs = []
      this.arr.forEach((res) => {
        this.arrs.push(res.url)
      })
      const data = await advertisementlistadd({
        monitor_status: this.radio,
        phone: this.telephone,
        urls: this.arrs
      })

      console.log('data', data)
      this.closempty()
      this.setdata()
      this.dialogVisible = false
    },
    closempty() {
      this.telephone = ''
      this.arr = [
        { url: '' }
      ]
      this.arrs = []
    },
    serarch() {
      this.setdata()
    },
    resetser() {
      this.query = {
        monitor_status: null,
        page: 1,
        page_size: 10,
        work_status: null,
        id: null
      }
      this.setdata()
    },
    // 分页
    fetchPageSize(e) {
      this.policyobj.pageSize = e
      this.setdata()
    },
    fetchCurrentPage(e) {
      this.policyobj.page = e
      this.setdata()
    },
    naclick(id, monitor_status, phone) {
      if (monitor_status === 1) {
        this.monitorstatus = 2
      } else {
        this.monitorstatus = 1
      }
      modifyDatar(id, this.monitorstatus, phone).then(res => {
        console.log('res', res)
        this.setdata()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    },
    deitphone(item) {
      this.dialogVisiblephone = true
      this.item = item
      this.edittelephone = item.phone

      console.log(item)
    },
    phonesunbit() {
      modifyDatar(this.item.id, this.item.monitor_status, this.edittelephone).then(res => {
        console.log('res', res)
        this.setdata()
        this.dialogVisiblephone = false
      })
    },
    async deleter(item) {
      const data = await deletemanag(item.id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.setdata()
      console.log('data', data)
    },
    reduceclick(index) {
      this.arr.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabletar{
  padding: 20px;
}
.sers{
  display: flex;
  align-items: center;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}
.link_box{
    max-height: 400px;
    overflow: auto;
}
.link_box::-webkit-scrollbar{ /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
.link_box::-webkit-scrollbar-thumb{ /*滚动条里面小方块*/
    border-radius: 10px;
    background: #cfcbcb;
}
.link_box::-webkit-scrollbar-track{ /*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
}
</style>
